//
// LogModulusAxisOptions.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "./NumericAxisOptions";
import "./LogarithmBase";

var LogModulusAxisOptions = createModule("gtl::LogModulusAxisOptions", ["commons::PropertyOwner","commons::BaseModel","gtl::GTLModel","gtl::NumericAxisOptions"], EventDispatcher, [
    ,
    {
        logBase: 4,
        tickValueFormat: 7,
        minorTickCount: 4,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default LogModulusAxisOptions;
